module.exports = __webpack_public_path__ + "img/logo-travel.9e725f23.svg";